import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { queryClient } from '@/lib/queryClient';

/**
 * 푸터 등에서 언어가 바뀌면 API 응답 문자열이 달라지므로 활성 쿼리를 무효화해 재요청한다.
 */
export default function I18nQueryInvalidation(): null {
	const { i18n } = useTranslation();

	useEffect(() => {
		const handler = (): void => {
			void queryClient.invalidateQueries();
		};
		i18n.on('languageChanged', handler);
		return () => {
			i18n.off('languageChanged', handler);
		};
	}, [i18n]);

	return null;
}
